import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';
import { useAuth0 } from '@auth0/auth0-react';

const fetchHomePlugYourWork = async (authenticatedFetch) => {
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL || '/api'}/plug-your-work?limit=4`);
  
  if (!response.ok) {
    throw new Error('Failed to fetch plug your work');
  }
  
  const data = await response.json();
  return data.data || [];
};

export const useHomePlugYourWork = () => {
  const { authenticatedFetch } = useAuthenticatedApi();
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  
  return useQuery({
    queryKey: ['homePlugYourWork'],
    queryFn: () => fetchHomePlugYourWork(authenticatedFetch),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error) => {
      // Retry up to 3 times with exponential backoff
      if (failureCount < 3) {
        return true;
      }
      return false;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000), // 1s, 2s, 4s, max 5s
    enabled: !authLoading && isAuthenticated && !!authenticatedFetch,
  });
};

